import { IRoute } from '../interfaces/routing';

import NotFound from '../pages/sessions/404';
import InternalError from '../pages/sessions/500';
import SignIn from '../pages/sessions/Sign-In';
import SignUp from '../pages/sessions/Sign-up';
import EmployeeSignIn from '../pages/sessions/EmployeeSign-In';
import EnterOtp from '../pages/sessions/Enter-Otp';
import VaccinationDetails from '../pages/VaccinationDetails/VaccinationDetails'
import PhysicalForm from '../pages/forms/physicalForm'
import IntakeForm from '../pages/forms/intakeForm';
import TestDetails from '../pages/TestDetails/testDetails';
import ConfirmationPhysical from '../pages/forms/confirmation_physical';

export const sessionRoutes: IRoute[] = [
  {
    path: 'confirmation',
    component: ConfirmationPhysical
  },
  {
    path: 'testDetails/:testName/:token',
    component: TestDetails
  },
  {
    path: 'vaccinationDetails/:vaccId',
    component: VaccinationDetails
  },
  {
    path: 'intakeform/:email',
    component: IntakeForm
  },
  {
    path: 'physicalform/:email',
    component: PhysicalForm
  },
  {
    path: 'EnterOtp',
    component: EnterOtp
  },
  {
    path: 'page-404',
    component: NotFound
  },
  {
    path: 'page-500',
    component: InternalError
  },
  {
    path: 'sign-in/:logoType',
    component: SignIn
  },
  {
    path: 'sign-in',
    component: SignIn
  },
  {
    path: 'sign-up',
    component: SignUp
  },
  {
    path: 'EmployeeSign-In',
    component: EmployeeSignIn
  }
];
